import { render, staticRenderFns } from "./AppliationList.vue?vue&type=template&id=331d3cc4&"
import script from "./AppliationList.vue?vue&type=script&lang=js&"
export * from "./AppliationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports